<template>
  <div class="modal_wrap bottom_modal" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal commu_btm_modal">
        <div class="con">
          <ul v-if="mode === 'POST_EDIT'">
            <li @click="fnPostEdit('MODIFY')">게시글 수정하기</li>
            <li @click="fnPostEdit('DELETE')">게시글 삭제하기</li>
          </ul>
          <ul v-else-if="mode === 'POST_REPORT'">
            <li @click="fnReport('REPORT_POST')">게시글 신고하기</li>
            <li @click="fnReport('REPORT_USER')">사용자 신고하기</li>
          </ul>
          <ul v-else-if="mode === 'COMME_EDIT'">
            <li @click="fnCommeEdit('MODIFY')">답글 수정하기</li>
            <li @click="fnCommeEdit('DELETE')">답글 삭제하기</li>
          </ul>
          <ul v-else-if="mode === 'COMME_MINE_EDIT'">
            <li @click="fnCommeEdit('DELETE')">답글 삭제하기</li>
          </ul>
          <ul v-else-if="mode === 'COMME_REPORT'">
            <li @click="fnReport('REPORT_COMME')">답글 신고하기</li>
            <li @click="fnReport('REPORT_USER')">사용자 신고하기</li>
          </ul>
        </div>
        <div class="btn_wrap">
          <button @click="fnClose()">
            닫기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'componment-community-bottom-modal',
  descriptoin: '커뮤니티 > 하단 팝업',
  props: {
    show: Boolean,
    mode: String,
  },
  methods: {
    fnReport(val) {
      this.$emit('report', val);
    },
    fnPostEdit(val) {
      this.$emit('post-edit', val);
    },
    fnCommeEdit(val) {
      this.$emit('comme-edit', val);
    },
    fnClose() {
      this.$emit('close');
    },
  },
};
</script>
